module.exports = __webpack_public_path__ + "img/Bildschirmfoto 2019-09-02 um 17.29.23.17c0aacc.png";